import {IGallerySantaProps} from '../types/galleryTypes';
import {IPropsInjectedByViewerScript} from '../types/sliderGalleryTypes';
import {IHostProps} from '@wix/native-components-infra/dist/es/src/types/types';
import {IStylesContextValue} from '@wix/tpa-settings';
import {IStylesParams} from '../styleParams/types';

type ProvidedGlobalPropNames =
  | 'allowFreeProducts'
  | 'addedToCartStatus'
  | 'experiments'
  | 'getCategoryProducts'
  | 'loadNextProductsIfNeeded'
  | 'loadPrevProductsIfNeeded'
  | 'loadProductsByGivenIndex'
  | 'handleAddToCart'
  | 'handleProductItemClick'
  | 'handleProductsOptionsChange'
  | 'handleWishlistToggle'
  | 'sendClickShippingInfoLinkSf'
  | 'host'
  | 'htmlTags'
  | 'imageMode'
  | 'imageRatio'
  | 'isFirstPage'
  | 'isInteractive'
  | 'isLiveSiteMode'
  | 'isPreviewMode'
  | 'shouldShowMobile'
  | 'isCategoryVisible'
  | 'isEditorMode'
  | 'isRTL'
  | 'isSEO'
  | 'isSSR'
  | 'isCatalogV3'
  | 'mainCollectionId'
  | 'openQuickView'
  | 'productsManifest'
  | 'productsVariantInfoMap'
  | 'products'
  | 'priceBreakdown'
  | 'shouldShowAddToCartSuccessAnimation'
  | 'shouldShowProductOptions'
  | 'textsMap'
  | 'totalProducts'
  | 'updateAddToCartStatus'
  | 'galleryType'
  | 'productsPriceRangeMap'
  | 'handleQuickAddToCart'
  | 'closeQuickAdd'
  | 'isSliderGallery'
  | 'reportSliderGalleryLoadedPanorama'
  | 'viewState'
  | 'userWishlistMap';

export interface ISliderGlobalProps {
  globals?: Pick<IPropsInjectedByViewerScript & IGallerySantaProps, ProvidedGlobalPropNames> & {
    styles: IStylesContextValue;
    stylesParams: IStylesParams;
  } & Pick<IHostProps, 'updateLayout' | 'dimensions' | 'appLoadBI'>;
}

export const sliderGlobalPropsStrategy = (props: IPropsInjectedByViewerScript & IGallerySantaProps) => {
  const {
    allowFreeProducts,
    addedToCartStatus,
    experiments,
    getCategoryProducts,
    loadNextProductsIfNeeded,
    loadPrevProductsIfNeeded,
    loadProductsByGivenIndex,
    handleAddToCart,
    handleProductItemClick,
    handleProductsOptionsChange,
    handleWishlistToggle,
    htmlTags,
    sendClickShippingInfoLinkSf,
    imageMode,
    imageRatio,
    isFirstPage,
    isInteractive,
    isLiveSiteMode,
    isPreviewMode,
    shouldShowMobile,
    isCategoryVisible,
    isEditorMode,
    isRTL,
    isSEO,
    isSSR,
    isCatalogV3,
    mainCollectionId,
    openQuickView,
    priceBreakdown,
    productsManifest,
    productsVariantInfoMap,
    products,
    shouldShowAddToCartSuccessAnimation,
    shouldShowProductOptions,
    textsMap,
    totalProducts,
    updateAddToCartStatus,
    productsPriceRangeMap,
    galleryType,
    handleQuickAddToCart,
    closeQuickAdd,
    isSliderGallery,
    reportSliderGalleryLoadedPanorama,
    viewState,
    userWishlistMap,
    ...locals
  } = props;

  const {appLoadBI, dimensions, updateLayout} = props.host;
  return {
    globals: {
      allowFreeProducts,
      addedToCartStatus,
      appLoadBI,
      dimensions,
      experiments,
      getCategoryProducts,
      loadNextProductsIfNeeded,
      loadPrevProductsIfNeeded,
      loadProductsByGivenIndex,
      handleAddToCart,
      handleProductItemClick,
      handleProductsOptionsChange,
      handleWishlistToggle,
      host: props.host,
      htmlTags,
      imageMode,
      imageRatio,
      isFirstPage,
      isInteractive,
      sendClickShippingInfoLinkSf,
      isLiveSiteMode,
      isPreviewMode,
      shouldShowMobile,
      isCategoryVisible,
      isEditorMode,
      isRTL,
      isSEO,
      isSSR,
      isCatalogV3,
      mainCollectionId,
      openQuickView,
      priceBreakdown,
      productsManifest,
      productsVariantInfoMap,
      products,
      shouldShowProductOptions,
      shouldShowAddToCartSuccessAnimation,
      textsMap,
      totalProducts,
      updateAddToCartStatus,
      updateLayout,
      galleryType,
      productsPriceRangeMap,
      handleQuickAddToCart,
      closeQuickAdd,
      isSliderGallery,
      reportSliderGalleryLoadedPanorama,
      viewState,
      userWishlistMap,
    },
    locals,
  };
};
